import { motion } from "framer-motion";
import { AuraMark } from "./AuraMark";

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

const BrandA = () => (
  <span className="inline-flex items-center align-middle -my-[0.4em] translate-y-[-0.08em]" data-testid="overline-brand-a">
    <AuraMark className="w-[1.55em] h-[1.55em] -mr-[0.12em]" />
    <span>ura</span>
    <span className="text-[#f43f5e]">_</span>
  </span>
);

const withBrandMark = (text) =>
  typeof text === "string"
    ? text.split(/(Aura_)/i).map((part, i) => (/^aura_$/i.test(part) ? <BrandA key={i} /> : part))
    : text;

export const Overline = ({ children, className = "" }) => (
  <p className={`font-mono text-xs uppercase tracking-[0.28em] text-sky-300 ${className}`}>{withBrandMark(children)}</p>
);
